import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";

const DropdownExLacChildren = ({ control, onChange, components, initialValue, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly } ) =>
{
    const mapFn = ( record )  =>
    {
        return {
            ...record, full_name: record.firstname + ' ' + record.surname + ' ( DoB ' + record.dmy_date_of_birth + ')'
        }
    }

    const [ loading, items ] = useListboxFetch( {
        url: '/children/exlac', keyFieldName: 'child_id', labelFieldName: 'full_name', mapFn } ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} components={components} initialValue={initialValue} control={control} onChange={onChange} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownExLacChildren;
